<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="epigraph">
<h1>Epigraph</h1>
<p>*…España,</p>
<p>madre de ríos y de espadas y de multiplicadas generaciones,</p>
<p>incesante y fatal.*</p>
<p>(…Spain,</p>
<p>mother of rivers and swords and multiplied generations,</p>
<p>incessant and fatal.)</p>
<p>Jorge Luis Borges, Buenos Aires, July 1964.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?729965da